import styled from "styled-components";

const Footer = () => {
  return (
    <>
      <FooterContainer>
        {/* <div>
                <h3>PROGRAMS</h3>
                <li>ABOUT US</li>
                <li>SUPPORT</li>
                <li>RAISING ROBOTICS CHAMPIONS</li>
                <li>PLAYING STEAM</li>
            </div> */}
        <div>
          <h3>CONTACT US</h3>
          <li>
            <i class="fa-solid fa-envelope"></i>hello@techforkids.uk
          </li>
          <li>
            <i class="fa-solid fa-phone-volume"></i>+44 7927 970178
          </li>
        </div>
        <div>
          <h3>FOLLOW US</h3>
          <a href="https://www.instagram.com/techforkidsuk?igsh=MWxrenR4c2t5NnFjaA==">
            <i className="fa-brands fa-instagram"></i>
          </a>
          {/* <i className="fa-brands fa-x-twitter"></i>
          <i className="fa-brands fa-facebook"></i> */}
        </div>
      </FooterContainer>
      <p>&copy; 2025 TECH FOR KIDS AND ALL RIGHT RESERVED</p>
    </>
  );
};

const FooterContainer = styled.footer`
  width: 100%;
  padding: 30px 0;
  margin-top: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  height: 280px;
  position: relative;

  & + p {
    text-align: center;
    padding: 10px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: .8rem;
    }
  }

  &::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #545454;
    width: 100%;
    top: 90%;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
       top: 95%;
      }
  }

  div {
    width: 33.3%;
    padding: 0 30px;
    h3 {
      font-size: 2rem;
    }
    li {
      font-family: "Montserrat", sans-serif;
      display: flex;
      width: 100%;
      align-items: center;
      list-style: none;
      padding: 5px 0;
      font-size: 1.2rem;

      i {
        font-size: 1.3rem;
        margin: 0 30px 0 0;
      }
    }
    i {
      font-size: 2rem;
      margin-right: 20px;
      margin-top: 20px;
      cursor: pointer;
      color: ${({ theme }) => theme.color.azure};

      &:hover {
        color: ${({ theme }) => theme.color.orange};
      }
      text-decoration: none;
    }
    a {
      font-size: 2rem;
      margin-top: 20px;
      cursor: pointer;
      color: ${({ theme }) => theme.color.azure};

      &:hover {
        color: ${({ theme }) => theme.color.orange};
      }
      text-decoration: none;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
      }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    height: 400px;
  }
`;

export default Footer;
